const FAQQuestions = [
    {
        id:1,
        question: 'What is the ethnic heritage of the Garinagu people?',
        answer: 'Arawak Indian, Carib Indian and West African.',
    },
    {
        id:2,
        question: 'What are the colors of the Garifuna flag and what do they represent?',
        answer: 'The Garifuna flag consists of three horizontal strips of black, white and yellow in that order starting from the top. The flag has been accepted internationally as the flag of the Garifuna Nation and the colors have been used in forums where Garifuna people assert their Garifuna identity'
    },
    { 
        id: 3,
        question: 'How many Garifuna people are there currently?',
        answer: 'The Garifuna population is estimated to be around 600,000 in total, taking together its people in Central America, Yurumein (Saint Vincent and the Grenadines), and the UnitedStates.'
    },
    {   
        id: 4,
        question: 'What is the significance of the November 19th celebrations?',
        answer: 'Every year on November 19, Garifuna Settlement day is observed which marks the arrival of the Garifuna people in Belizean territory in 1802. The holiday was created by Thomas Vincent Ramos, a Belizean civil rights activist and is celebrated for a whole week with major festivities that include parades, live music, drumming, dancing, prayers and pageantry in Garifuna communities.'
    },
    {
        id: 5,
        question: 'When it comes to spirituality, what is the Garifuna belief?',
        answer: 'The religion of the Garifuna consists of a mix of Catholicism, African and Indian beliefs. They believe that the departed ancestors mediate between the individual and external world and if a person behaves and performs well, then he will have good fortune. If not, then the harmony that exists in relationships with others and the external world will be disrupted leading to misfortune and illness.Their spiritualism is expressed through music, dancing and other art forms.'
    },
    {
        id: 6,
        question: 'What are the main staples of the Garinagu diet?',
        answer: 'The Garifuna foods consist of fish, chicken, cassava, bananas and plantains. One of the staples of the diet is cassava. Cassava is made into bread, a drink, a pudding and even a wine!'
    },
   
]

export default FAQQuestions;